"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTrustPaymentOptions = void 0;
const common_1 = require("../../common");
const common_2 = require("../common");
const trust_options_validator_1 = require("./trust-options-validator");
function calculateTrustPaymentOptions(options) {
    const validation = trust_options_validator_1.validateTrustOptions(options);
    if (!validation.isValid) {
        return Object.assign(Object.assign({}, validation), { paymentOptions: [] });
    }
    const paymentOptions = options.paymentMode === common_1.PaymentMode.Single
        ? calculateSinglePayment(options.amount)
        : calculateMultiPayment(options.amount);
    return {
        isValid: true,
        errors: [],
        paymentOptions,
    };
}
exports.calculateTrustPaymentOptions = calculateTrustPaymentOptions;
function calculateSinglePayment(amount) {
    return [
        {
            years: 0,
            numberOfPayments: 0,
            premium: amount,
            faceAmount: amount,
            amountOfFirstPayment: amount,
            paymentMode: common_1.PaymentMode.Single,
            paymentPeriod: null,
        },
    ];
}
function calculateMultiPayment(amount) {
    return [
        calculatePaymentOptionForNumberOfYears(amount, 1),
        calculatePaymentOptionForNumberOfYears(amount, 3),
        calculatePaymentOptionForNumberOfYears(amount, 5),
    ];
}
function calculatePaymentOptionForNumberOfYears(amount, years) {
    const monthlyPremium = calculateMonthlyPremium(amount, years);
    return {
        years,
        numberOfPayments: years * common_2.MONTHS_IN_YEAR,
        premium: monthlyPremium,
        amountOfFirstPayment: calculateAmountOfFirstPayment(amount, years, monthlyPremium),
        faceAmount: amount,
        paymentMode: common_1.PaymentMode.Multi,
        paymentPeriod: common_1.PaymentPeriod.Monthly,
    };
}
function calculateMonthlyPremium(amount, years) {
    const monthlyAmount = amount / (years * common_2.MONTHS_IN_YEAR);
    return common_2.roundDown(monthlyAmount);
}
function calculateAmountOfFirstPayment(amount, years, premium) {
    const result = amount - premium * (years * common_2.MONTHS_IN_YEAR - 1);
    return common_2.roundPayment(result);
}
//# sourceMappingURL=trust-payment-calculator.js.map